import { styled } from '@mui/material/styles';

const StyledDeleteIcon = styled('div')`
  cursor: pointer;

  &:hover {
    pointer: hand;
  }
`;

export default StyledDeleteIcon;
